import { RestaurantClosures } from "./RestaurantClosures";

export default RestaurantClosures;
